module.exports = __webpack_public_path__ + "static/app-store-ec377aec45867bee2d4b46d51c1345e7.png";